import React, { useState } from "react";
import api from "../api";

function AttendanceForm() {
  const [message, setMessage] = useState("");

  const markAttendance = async () => {
    try {
      const res = await api.post("/api/attendance/mark");
      setMessage(res.data.message + " at " + res.data.at);
    } catch (err) {
      setMessage("Error: " + (err.response?.data?.message || "Failed"));
    }
  };

  return (
    <div>
      <h2>Attendance</h2>
      <button onClick={markAttendance}>Mark Attendance</button>
      <p>{message}</p>
    </div>
  );
}

export default AttendanceForm;
